import { createRoot } from "react-dom/client";

import { App } from "./App";

// biome-ignore lint/style/noNonNullAssertion: we're fucked if we don't
const rootElement = document.getElementById("root")!;

if (!rootElement.innerHTML) {
  const root = createRoot(rootElement);
  root.render(<App />);
}
